import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { TimeBasedSettingForAllCallersRequest } from './timebasedsettingforallcallersrequest';
import { TimeBasedSettingForAllCallersDto } from '../../../dto/timebasedsetting/timebasedsettingforallcallersdto';
import { WeekDaysToNumberConverter } from '../../../dto/timebasedsetting/weekdaystonumberconverter';
import { Strings } from '../../../../utils/resources/strings';
import * as moment from 'moment';
import { DateTransform } from '../../../../ui/toolkit/datetransform/datetransform';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class TimeBasedSettingForAllCallersAPI extends SixdeeCRBTAPI<TimeBasedSettingForAllCallersRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod()
    {
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/time-based-setting-for-already-activated
        return "time-based-setting-for-already-activated";
    }

    getRequestData()
    {
        let timeBasedSettingForAllCallersRequestDto : TimeBasedSettingForAllCallersDto;
        timeBasedSettingForAllCallersRequestDto = this.getRequest().getTimeBasedSettingForAllCallersRequest();

        let commonRequestParameters : string = "clientTxnId=21072020"+"&"+
        "aPartyMsisdn=" + timeBasedSettingForAllCallersRequestDto.getAPartyMsisdn()+"&"+
        "toneId="+ timeBasedSettingForAllCallersRequestDto.getToneId()+"&"+
        "language="+ (timeBasedSettingForAllCallersRequestDto.getLanguage() === LanguageConst.ENGLISH ? "1": "2")+"&"+
        "priority="+ timeBasedSettingForAllCallersRequestDto.getPriority()+"&"+
        "channelId="+ timeBasedSettingForAllCallersRequestDto.getChannelId()+"&"+
        "serviceId=" + timeBasedSettingForAllCallersRequestDto.getServiceId()+"&"+
        "activityId="+ timeBasedSettingForAllCallersRequestDto.getActivityId();

        let timeSettingSelected = timeBasedSettingForAllCallersRequestDto.getTimeSettingSelected();
        
        if(timeSettingSelected === this.getContext().getResources().getString(Strings.full_day))
        {
            return commonRequestParameters+"&"+
            "timeType="+ this.getContext().getResources().getString(Strings.WEEKLY_TIME) +"&"+
            "weeklyDays="+ new WeekDaysToNumberConverter().convertWeekDaysToNumber(timeBasedSettingForAllCallersRequestDto.getWeeklyDays())+"&"+
            "weeklyStartTime="+ this.getContext().getResources().getString(Strings.default_start_time)+"&"+
            "weeklyEndTime="+ this.getContext().getResources().getString(Strings.default_end_time);
        }
        else if(timeSettingSelected === this.getContext().getResources().getString(Strings.select_time))
        {
            return commonRequestParameters+"&"+
            "timeType="+ this.getContext().getResources().getString(Strings.WEEKLY_TIME) +"&"+
            "weeklyDays="+ new WeekDaysToNumberConverter().convertWeekDaysToNumber(timeBasedSettingForAllCallersRequestDto.getWeeklyDays())+"&"+
            "weeklyStartTime="+ timeBasedSettingForAllCallersRequestDto.getStartTimestamp() +"&"+
            "weeklyEndTime="+ timeBasedSettingForAllCallersRequestDto.getEndTimestamp();
        }
        else
        {
            let repeatInterval = timeBasedSettingForAllCallersRequestDto.getRepeatInterval();
            let startDate = timeBasedSettingForAllCallersRequestDto.getStartTimestamp().split(" ");
            let endDate = timeBasedSettingForAllCallersRequestDto.getEndTimestamp().split(" ");
                
            if(repeatInterval === this.getContext().getResources().getString(Strings.none))
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.CUSTOM_TIME) +"&"+
                   //"customizeStartDate="+ moment(startDate[0], "DD/MM/yyyy").format("yyyy-MM-DD") +"&"+
                   "customizeStartDate="+ DateTransform.formatDateForBackend(startDate[0]) +"&"+
                   //"customizeEndDate="+ moment(endDate[0], "DD/MM/yyyy").format("yyyy-MM-DD") +"&"+
                   "customizeEndDate="+ DateTransform.formatDateForBackend(endDate[0]) +"&"+
                   "customizeStartTime="+ startDate[1] +"&"+
                   "customizeEndTime="+ endDate[1];
            }
            else if(repeatInterval === this.getContext().getResources().getString(Strings.monthly))
            {
                let startDateformat = moment(startDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");
                let endDateformat = moment(endDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");
    
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.MONTHLY_TIME) +"&"+
                   /* "startDayMonthly="+ String(moment(startDateformat).date()) +"&"+
                   "endDayMonthly="+ String(moment(endDateformat).date()) +"&"+ */
                   "startDayMonthly="+ String(moment(startDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "endDayMonthly="+ String(moment(endDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "monthlyStartTime="+ startDate[1] +"&"+
                   "monthlyEndTime="+ endDate[1];

            }
            else if(repeatInterval === this.getContext().getResources().getString(Strings.yearly))
            {
                let startDateformat = moment(startDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");
                let endDateformat = moment(endDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");

                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.YEARLY_TIME) +"&"+
                   //"yearlyStartMonth="+ String(moment(startDateformat).month() + 1) +"&"+
                   //"yearlyEndMonth="+ String(moment(endDateformat).month() + 1) +"&"+
                   //"yearlyStartDay="+ String(moment(startDateformat).date()) +"&"+
                   //"yearlyEndDay="+ String(moment(endDateformat).date()) +"&"+
                   "yearlyStartMonth="+ String(moment(startDateformat, 'MM/DD/YYYY').format('MM')) +"&"+
                   "yearlyEndMonth="+ String(moment(endDateformat, 'MM/DD/YYYY').format('MM')) +"&"+
                   "yearlyStartDay="+ String(moment(startDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "yearlyEndDay="+ String(moment(endDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "yearlyStartTime="+ startDate[1] +"&"+
                   "yearlyEndTime="+ endDate[1];
            }
            else
            {
                return "";
            }
        }



        
        /* // ALL CALLER - Full Day/Specific Time - Selected days of the week
        if(timeBasedSettingForAllCallersRequestDto.getWeeklyStartTime() !== undefined &&
        timeBasedSettingForAllCallersRequestDto.getWeeklyEndTime() !== undefined)
        {
            return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.WEEKLY_TIME) +"&"+
                   "weeklyDays="+ new WeekDaysToNumberConverter().convertWeekDaysToNumber(timeBasedSettingForAllCallersRequestDto.getWeeklyDays())+"&"+
                   "weeklyStartTime="+ timeBasedSettingForAllCallersRequestDto.getWeeklyStartTime()+"&"+
                   "weeklyEndTime="+ timeBasedSettingForAllCallersRequestDto.getWeeklyEndTime();
        }
        else // ALL CALLER - Specific Date & Time
        {
            // ALL CALLER - Specific Date & Time - Monthly repeat
            if(timeBasedSettingForAllCallersRequestDto.getStartDayMonthly() !== undefined &&
            timeBasedSettingForAllCallersRequestDto.getEndDayMonthly() !== undefined)
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.MONTHLY_TIME) +"&"+
                   "startDayMonthly="+ timeBasedSettingForAllCallersRequestDto.getStartDayMonthly()+"&"+
                   "endDayMonthly="+ timeBasedSettingForAllCallersRequestDto.getEndDayMonthly()+"&"+
                   "monthlyStartTime="+ timeBasedSettingForAllCallersRequestDto.getMonthlyStartTime()+"&"+
                   "monthlyEndTime="+ timeBasedSettingForAllCallersRequestDto.getMonthlyEndTime();
            } // ALL CALLER - Specific Date & Time - Yearly repeat
            else if(timeBasedSettingForAllCallersRequestDto.getYearlyStartMonth() !== undefined &&
                    timeBasedSettingForAllCallersRequestDto.getYearlyEndMonth() !== undefined)
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.YEARLY_TIME) +"&"+
                   "yearlyStartMonth="+ timeBasedSettingForAllCallersRequestDto.getYearlyStartMonth()+"&"+
                   "yearlyEndMonth="+ timeBasedSettingForAllCallersRequestDto.getYearlyEndMonth()+"&"+
                   "yearlyStartDay="+ timeBasedSettingForAllCallersRequestDto.getYearlyStartDay()+"&"+
                   "yearlyEndDay="+ timeBasedSettingForAllCallersRequestDto.getYearlyEndDay()+"&"+
                   "yearlyStartTime="+ timeBasedSettingForAllCallersRequestDto.getYearlyStartTime()+"&"+
                   "yearlyEndTime="+ timeBasedSettingForAllCallersRequestDto.getYearlyEndTime();
            }
            else // ALL CALLER - Specific Date & Time - NO repeat
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.CUSTOM_TIME) +"&"+
                   "customizeStartDate="+ timeBasedSettingForAllCallersRequestDto.getCustomizeStartDate()+"&"+
                   "customizeEndDate="+ timeBasedSettingForAllCallersRequestDto.getCustomizeEndDate()+"&"+
                   "customizeStartTime="+ timeBasedSettingForAllCallersRequestDto.getCustomizeStartTime()+"&"+
                   "customizeEndTime="+ timeBasedSettingForAllCallersRequestDto.getCustomizeEndTime();
            }
        } */
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersapi.tsx